// extracted by mini-css-extract-plugin
module.exports = {"crumbs":"PageContainer_crumbs__1VCK-","main":"PageContainer_main__27wjY","content":"PageContainer_content__jnGTm","sidebar":"PageContainer_sidebar__1-H6D"};